import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullTag from "../fragments/fullTag"

const query = gql`
  query Tags($ids: [ID], $kind: String, $limit: Int, $locale: String, $offset: Int, $withChildren: Boolean!) {
    tags(ids: $ids, kind: $kind, limit: $limit, locale: $locale, offset: $offset) {
      results {
        ...fullTag
      }
      limit
      offset
      hasMore
      total
    }
  }
  ${fullTag}
`

export const tagsKey = getQueryNames(query)[0]

export default query
